import React from 'react'
import SocialFasho from '../../assets/Images/fashionBG.svg'
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';


const SectionTwo = () => {
    return (
        <>
               <div className="mx-auto bg-gray-900  px-4 xl:px-0 py-10 xl:py-40 text-white max-w-full">
                    <div className="flex flex-wrap items-center justify-center">
                        <div className="lg:w-2/5 w-full ">
                            <img className="w-full" src={SocialFasho} />
                        </div>
                        <div className="lg:w-1/2 w-full">
                            <div className="lg:pl-8 py-2 text-color">
                                <h1 className="text-3xl xl:text-6xl leading-snug font-black">Sleek Social Feed catered towards your style </h1>
                                <h2 className="text-xl lg:text-3xl leading-7 lg:leading-10  py-4 lg:py-8">Use Fashos Social Feed to Demonstrate your fashion sense and styling across the globe! 🌍</h2>
                                <Link to="/social">
                                    <button className="text-xl w-full xl:text-3xl xl:w-9/12 mt-4 xl:mt-11 py-6 bg-linear-button-home text-white ">
                                        <span className="text-white">
                                            Social Feed
                                        </span>
                                        <ArrowForwardIcon className="mx-2" />
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    )
}

export default SectionTwo